import { createIconComponent } from '../../factory/create-icon-component';
export const FlashIcon = createIconComponent(
  'FlashIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.11939 10.1007L9.72588 4.34261C11.0367 2.70406 11.6921 1.88479 12.2669 1.79439C12.7644 1.71614 13.268 1.89278 13.6076 2.26468C14 2.69433 14 3.74351 14 5.84187V7.6C14 8.44008 14 8.86012 14.1635 9.18099C14.3073 9.46323 14.5367 9.6927 14.819 9.83651C15.1399 10 15.5599 10 16.4 10H17.0065C18.605 10 19.4043 10 19.8148 10.3277C20.1718 10.6127 20.3795 11.0448 20.379 11.5016C20.3785 12.0269 19.8792 12.651 18.8806 13.8993L14.2741 19.6574C12.9632 21.2959 12.3078 22.1152 11.733 22.2056C11.2355 22.2839 10.7319 22.1072 10.3923 21.7353C9.99997 21.3057 9.99997 20.2565 9.99997 18.1581V16.4C9.99997 15.5599 9.99997 15.1399 9.83648 14.819C9.69267 14.5368 9.4632 14.3073 9.18096 14.1635C8.86009 14 8.44005 14 7.59997 14H6.99347C5.39492 14 4.59564 14 4.18513 13.6723C3.82811 13.3873 3.62041 12.9552 3.62091 12.4984C3.62147 11.9731 4.12078 11.349 5.11939 10.1007Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
